import React, { useEffect, useRef, useState } from 'react';

// Fades/slides children in once they scroll into view. Content is visible
// immediately when IntersectionObserver is unavailable (old browsers, tests),
// and reduced-motion users are handled in CSS (.reveal is a no-op there).
function Reveal({ as: Tag = 'div', delay = 0, className = '', children, ...rest }) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(
        () => typeof window === 'undefined' || !('IntersectionObserver' in window)
    );

    useEffect(() => {
        if (visible || !ref.current) return undefined;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
        );
        observer.observe(ref.current);
        return () => observer.disconnect();
    }, [visible]);

    return (
        <Tag
            ref={ref}
            className={`reveal${visible ? ' is-visible' : ''} ${className}`.trim()}
            style={{ '--reveal-delay': `${delay}ms` }}
            {...rest}
        >
            {children}
        </Tag>
    );
}

export default Reveal;
